export default __webpack_public_path__ + "static/media/chev-left-blue.2b48325f.svg";